import type { IconDefinition } from '@vrplatform/icons';
import type { GuestBalancesOccupancyStatus } from './useGuestBalancesTableFilter';

type GuestBalancesOccupancyStatusCard = {
  title: string;
  icon: IconDefinition;
  type: GuestBalancesOccupancyStatus;
  description: string;
};

export const guestBalancesOccupancyStatusCards = [
  {
    title: 'Unassigned',
    icon: 'CommentQuestionIcon',
    type: 'unassigned',
    description: 'Not linked to a reservation',
  },
  {
    title: 'Cancelled',
    icon: 'CalendarCrossIcon',
    type: 'cancelled',
    description: 'Cancelled reservations',
  },
  {
    title: 'Departed',
    icon: 'ForwardRecIcon',
    type: 'departed',
    description: 'Guest checked out',
  },
  {
    title: 'In-House',
    icon: 'HomeIcon',
    type: 'inHouse',
    description: 'Guest checked in, but not departed',
  },
  {
    title: 'Advance Deposits',
    icon: 'CalendarArrowRightIcon',
    type: 'upcoming',
    description: 'Guest not checked in',
  },
  {
    title: 'All reservations',
    icon: 'FunctionsRecIcon',
    type: 'all',
    description: 'Includes all reservations, regardless of status',
  },
] satisfies readonly GuestBalancesOccupancyStatusCard[];
